"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.replace");
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.number.constructor");
var _member = require("@/api/member/member");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: '',
  props: {
    memberId: {
      type: Number,
      default: null
    }
  },
  data: function data() {
    return {
      RelationChinaDate: []
    };
  },
  mounted: function mounted() {
    this.memberQueryRelationChainApi();
  },
  methods: {
    memberQueryRelationChainApi: function () {
      var _memberQueryRelationChainApi2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var params, res, _t;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              params = {
                memberId: this.memberId
              };
              _context.n = 1;
              return (0, _member.memberQueryRelationChainApi)(params);
            case 1:
              res = _context.v;
              if (res.code === 0) {
                this.RelationChinaDate = res.data;
              }
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              console.log(_t);
            case 3:
              return _context.a(2);
          }
        }, _callee, this, [[0, 2]]);
      }));
      function memberQueryRelationChainApi() {
        return _memberQueryRelationChainApi2.apply(this, arguments);
      }
      return memberQueryRelationChainApi;
    }(),
    onSelect: function onSelect(value) {
      this.$router.replace({
        path: '/member/userDetails',
        query: {
          memberId: value.memberId,
          nickname: value.nickname
        }
      });
    }
  }
};